<template>
    <div class="page">
      <img class="topImg" src="../assets/img/1_1.jpg">
      <div class="contentView">
        <div class="titleView">
          <div style="">PRODUCT</div>
          <div class="titleMsg">产品介绍</div>
        </div>
        <div class="product_t">
          <div class="productItems">
            <div class="productItem"
              v-for="(item,index) in products"
              :key="item.name"
              :class="{productSel:(productSel==index)}"
              @click="productTouch(index)"
            >{{item.name}}</div>
          </div>
        </div>
        <div class="product_b">
          <van-swipe :autoplay="5000" ref="banner" height="160" indicator="none" @change="carouselChange">
            <van-swipe-item v-for="item in products" :key="item.name">
              <img style="width: 100%; height: 100%; object-fit: cover;" :src="item.img" alt="">
            </van-swipe-item>
            <template #indicator>
              <div></div>
            </template>
          </van-swipe>
          <img class="bannerBtn_left bannerBtn" @click="bannerChange('prev')" src="../assets/img/banner_left.png"/>
          <img class="bannerBtn_right bannerBtn" @click="bannerChange('next')" src="../assets/img/banner_right.png"/>
        </div>
        <div class="titleView">
          <div style="">DYNAMICS</div>
          <div class="titleMsg">公司动态</div>
        </div>
        <div class="trends">
          <div class="trendsItem" v-for="item in trends" :key="item.title" @click="trendsTouch(item.code)">
            <span class="trendsItemTopTitle">{{item.title}}</span>
            <img :src="item.img">
            <span>{{item.title}}</span>
            <div class="line"></div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);
import 'vant/lib/index.css';
export default {
  data () {
    return {
      products:[
        {
          name: '5口  T1',
          img: require('../assets/img/slide_1.jpg')
        },
        {
          name: '10口  T2',
          img: require('../assets/img/slide_2.jpg')
        },
        {
          name: '15口  T3',
          img: require('../assets/img/slide_3.jpg')
        },
        {
          name: '广 告 机',
          img: require('../assets/img/slide_4.jpg')
        }],
      productSel: 0,
      trends:[
        {
          title: '公司动态',
          code: 'trends',
          img: require('../assets/img/1_3.jpg')
        },
        {
          title: '品牌合作',
          code: 'collaborate',
          img: require('../assets/img/1_4.jpg')
        },
        {
          title: '速绿-永不止步',
          code: 'sulv',
          img: require('../assets/img/1_5.jpg')
        },
      ],
      trendsSel: 0
    };
  },
  components: {},
  mounted () {},
  methods: {
    productTouch(index){
      this.productSel = index
      this.$refs.banner.swipeTo(index)
    },
    carouselChange(index){
      this.productSel = index;
    },
    bannerElect(index){
      this.$refs.banner.swipeTo(index);
    },
    bannerChange(res) {
      if (res == 'prev') {
        this.$refs.banner.prev();
      } else {
        this.$refs.banner.next();
      }
    },
    trendsTouch(code){
      this.$router.push({
          path: 'trends',
          query: { code }
        })
    },
  }
}
</script>

<style lang='scss' scoped>
.my-swipe{
  width: 80%;
  margin: 0 auto;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
  

.page{
  font-weight: 500;
  margin: 0 auto;
  font-size: 0.18rem;
  width: 100%;
}
.topImg{
  width: 100%;
  height: auto;
}
.contentView{
  margin: auto;
}
.titleView{
  margin: 0.2rem 0;
  display: flex;
  align-items:center;
  justify-content: center;
  font-size:20px;
  .titleMsg{
    font-size:0.14rem;
    margin-left:0.05rem;
    padding-left:0.05rem;
    border-left: 3px solid #2EB94F
  }
}
.product_t{
  text-align: left;
  width: 100%;
}
.productItems{
  display: flex;
  justify-content: center;
  margin-top: 0.2rem;
}
.productItem{
  width: 15%;
  height: 0.40rem;
  line-height: 0.40rem;
  border: 1px solid #2EB94F;
  color: #2EB94F;
  text-align: center;
  margin: 0 0.1rem;
}
.productSel{
  background: #2EB94F;
  color: white;
}
.product_b{
  width: 90%;
  margin: 0.2rem auto;
  position: relative;
}
.bannerBtn{
  position: absolute;
  border: 0;
  top: 70px;
  width: 12px;
  height: 22px;
  background-size: 100% 100%;
  z-index: 100;
  outline: none;
}
.bannerBtn_left {
  left: 0.1rem;
}
.bannerBtn_right {
  right: 0.1rem;
}
.trends{
  width: 90%;
  margin: 0 auto 0.2rem auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .trendsItem{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30%;
    .trendsItemTopTitle{
      background: #2EB94F;
      width: 100%;
      color: white;
      height: 0.3rem;
      line-height: 0.3rem;
    }
    img{
      width: 100%;
      height: auto;
      margin-bottom: 0.1rem;
    }
    .line{
      width: 0.6rem;
      height: 2px;
      background: #2EB94F;
      margin-top: 0.05rem;
    }
  }
}
</style>